var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',{staticClass:"justify-content-center"},[_c('CCol',{staticClass:"align-self-center col-md-9 col-lg-7"},[_c('div',{staticClass:"page-title"},[_c('span',[_vm._v("回答ありがとうございました")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }